import ApiV2 from "Api/ApiV2";
import { IPusherApi, PusherEventsResult} from "@connect/Interfaces";

export default class PusherApi extends ApiV2 implements IPusherApi {
	getMissedEvents(channel: string, lastSeen: string) {
		return this.GET(`messaging/${ channel }?after=${ lastSeen }`, {}, true) as Promise<PusherEventsResult>;
	}
}